export default __webpack_public_path__ + "static/media/Arrow-Blue-up.3b7ffa79.svg";